module.exports = __webpack_public_path__ + "static/media/job2.850af895.svg";